import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import ImageRenderer from '@/molecules/CustomMarkdown/components/ImageRenderer';
import ListRenderer from '@/molecules/CustomMarkdown/components/ListRenderer';
import StrongRenderer from '@/molecules/CustomMarkdown/components/StrongRenderer';
import { H1Renderer, H2Renderer, H3Renderer, H4Renderer, H5Renderer, H6Renderer } from './components/Headings';
import HrRenderer from './components/HrRenderer';
import LinkRenderer from './components/LinkRenderer';
import ParagraphRenderer from './components/ParagraphRenderer';
import BlockquoteRenderer from './components/QuoteRenderer';
import { TableRenderer, TdRenderer, TheadRenderer, ThRenderer, TrRenderer } from './components/Tables';

type CustomMarkdownProps = { className?: string; children: string | null | undefined };

const BrRenderer = () => <br />; // br ne marche pas =(

const CustomMarkdown = ({ children, className }: CustomMarkdownProps) => (
  <div className={className}>
    <ReactMarkdown
      components={{
        // headings
        h1: H1Renderer,
        h2: H2Renderer,
        h3: H3Renderer,
        h4: H4Renderer,
        h5: H5Renderer,
        h6: H6Renderer,
        // texts
        p: ParagraphRenderer,
        a: LinkRenderer,
        blockquote: BlockquoteRenderer,
        strong: StrongRenderer,
        hr: HrRenderer,
        // lists
        ul: ListRenderer,
        img: ImageRenderer,
        br: BrRenderer,
        // tables
        table: TableRenderer,
        tr: TrRenderer,
        th: ThRenderer,
        thead: TheadRenderer,
        td: TdRenderer,
      }}
      remarkPlugins={[remarkGfm]}
    >
      {children}
    </ReactMarkdown>
  </div>
);

export default CustomMarkdown;
